import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import {
    UntypedFormBuilder,
    UntypedFormGroup,
    Validators
} from '@angular/forms';
import {
    MatDialog,
    MatDialogConfig,
    MatDialogRef
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import { of, zip } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import {
    CustomValidators,
    DomainService,
    ErroMessages,
    IErroMessages,
    IRoute,
    Pattern,
    TokenService
} from 'viggo-sistemas-core-web';

import { IParceiro } from '@app/modules/parceiro/model';
import { ParceiroService } from '@app/modules/parceiro/services/parceiro.service';

import { Utils } from '@app/shared/helpers/utils';

import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import {
    IMotorista,
    TIPO_CNH
} from '@app/modules/motorista/models/motorista.model';
import { MotoristaService } from '@app/modules/motorista/services/motorista.service';
import { DialogConsultaPredictusComponent } from '@app/modules/parceiro/components';
import {
    ConfirmDialogComponent,
    ConfirmDialogData
} from '@app/shared/components';
import { ScreenService } from '@app/shared/services';
import { Dialog } from 'primeng/dialog';
import {
    validateCnpj,
    validateCpf
} from '../../../../shared/utils/validators_cpf_cnpj';
import { FastContatoComponent } from '../fast-contato/fast-contato.component';
import { FastEnderecoComponent } from '../fast-endereco/fast-endereco.component';

@Component({
  selector: 'app-fast-motorista',
  templateUrl: './fast-motorista.component.html',
  styleUrls: ['./fast-motorista.component.scss'],
  providers: [ParceiroService, MotoristaService]
})
export class FastMotoristaComponent implements OnInit, AfterViewInit {
  @ViewChild('fastMotorista') fastMotorista: Dialog;
  @ViewChild(FastEnderecoComponent)
  public _fastEndereco: FastEnderecoComponent;

  @ViewChild(FastContatoComponent)
  public _fastContato: FastContatoComponent;

  cpfCnpjMask = '000.000.000-00*';
  form: UntypedFormGroup;
  findParceiro = false;
  loadingParceiro = false;
  tipoCategoria: { label: string; value: string }[];

  messages = {
    cpf_cnpj: {
      repeated: 'Informação já cadastrada.',
      mask: 'Valor inválido.',
      required: 'O CPF/CNPJ é obrigatório',
      pattern: 'Este CPF/CNPJ é inválido.',
      maxlength: 'O CPF/CNPJ deve conter no máximo 14 caracteres.',
      validateCPF: 'Este CPF é inválido.',
      validateCNPJ: 'Este CNPJ é inválido.',
      duplicate:
        'CPF/CNPJ já existe na base de dados. Verifique se o cadastro existente com esse dado esta correto.'
    },
    apelido_nome_fantasia: {
      required: 'Esta informação é obrigatória.',
      minlength: 'Este nome é muito curto',
      maxlength: 'Este nome é muito longo.',
      isEmptyValue: 'Valor inválido, remova os espaços!'
    },
    nome_razao_social: {
      required: 'Esta informação é obrigatória.',
      maxlength: 'O nome deve conter no máximo 60 caracteres',
      minlength: 'Esta razão social é muito curta.',
      isEmptyValue: 'Valor inválido, remova os espaços!'
    },
    cnh: {
      required: 'CNH é obrigatória',
      maxlength: 'A CNH deve conter no máximo 11 caracteres.',
      isEmptyValue: 'Valor inválido, remova os espaços!',
      duplicate: 'CNH duplicada!'
    },
    cnh_categoria: {
      required: 'Categoria da CNH é obrigatória'
    },
    rg: {
      pattern: 'Este RG é invalido.',
      maxlength: 'O RG deve conter no máximo 20 caracteres.',
      existSpecialChar: 'Valor inválido, não aceita pontuação!',
      isEmptyValue: 'Valor inválido, remova os espaços!'
    },
    rg_insc_est: {
      pattern: 'Este valor é inválido.',
      maxlength: 'O campo deve conter no máximo 20 caracteres.',
      duplicate: 'O RG/Insc. Estadual já existe na base de dados!',
      existSpecialChar: 'Valor inválido, não aceita pontuação!',
      isEmptyValue: 'Valor inválido, remova os espaços!'
    }
  };

  viewInit = false;

  entity: IMotorista = {
    parceiro: {
      contatos: [],
      enderecos: []
    } as IParceiro
  } as IMotorista;

  focusElement: any;
  inputElementDtNasc: boolean;
  inputElementDtCNH: boolean;
  ID_FIELD_DTNASC = 'field-data-nascimento';
  ID_DTPICKER_NASC = 'dtPickerToggleDtNasc';
  ID_FIELD_DTCNH = 'field-validade-cnh';
  ID_DTPICKER_CNH = 'dtPickerToggleDtCNH';

  constructor(
    public screenService: ScreenService,
    public dialogRef: MatDialogRef<FastMotoristaComponent>,
    public entityService: MotoristaService,
    protected tokenService: TokenService,
    private domainService: DomainService,
    private parceiroService: ParceiroService,
    public matSnackBar: MatSnackBar,
    public matDialog: MatDialog,
    public router: Router,
    private fb: UntypedFormBuilder
  ) {
    this.tipoCategoria = Utils.enumToLisObjet(TIPO_CNH);
  }

  ngOnInit() {
    this.form = this.fb.group({
      nome_razao_social: [
        this.entity.parceiro.nome_razao_social || '',
        [
          Validators.required,
          Validators.maxLength(60),
          Validators.minLength(1),
          CustomValidators.isEmptyValue()
        ]
      ],
      apelido_nome_fantasia: [
        this.entity.parceiro.apelido_nome_fantasia || '',
        [
          Validators.minLength(1),
          Validators.maxLength(60),
          CustomValidators.isEmptyValue()
        ]
      ],
      cpf_cnpj: [this.entity.parceiro.cpf_cnpj || '', [Validators.required]],
      rg_insc_est: [
        this.entity.parceiro.rg_insc_est || '',
        [
          Validators.pattern(Pattern.patternInscEstadual()),
          Validators.maxLength(20),
          CustomValidators.existSpecialChar(),
          CustomValidators.isEmptyValue()
        ]
      ],
      codigo: [this.entity.codigo || ''],
      cnh: [
        this.entity.cnh || '',
        [
          Validators.required,
          Validators.maxLength(11),
          CustomValidators.isEmptyValue()
        ]
      ],
      cnh_validade: [this.entity.cnh_validade || null, [Validators.required]],
      data_nascimento: [this.entity.parceiro.data_nascimento || null],
      cnh_categoria: [this.entity.cnh_categoria || '', [Validators.required]]
    });
    this.form.controls.cpf_cnpj.valueChanges.subscribe(vl => {
      if (vl.toString().length <= 11) {
        this.cpfCnpjMask = '000.000.000-00*';
      } else {
        this.cpfCnpjMask = '00.000.000/0000-00';
      }
      this.removeValidatorMask();
      this.validar();
    });
  }

  removeValidatorMask() {
    const { cpf_cnpj } = this.form.controls;
    if (cpf_cnpj.hasError('mask')) cpf_cnpj.setErrors(null);
  }

  validar() {
    const cpfCnpjValue = this.form.controls.cpf_cnpj.value;
    if (cpfCnpjValue.toString().length <= 11) {
      if (validateCpf(cpfCnpjValue)) {
        this.form.controls.cpf_cnpj.setErrors({ validateCPF: true });
        this.form.updateValueAndValidity();
      }
    } else if (validateCnpj(cpfCnpjValue)) {
      this.form.controls.cpf_cnpj.setErrors({ validateCNPJ: true });
      this.form.updateValueAndValidity();
    }
  }

  public setInformacoesParceiro(
    parceiro: IParceiro = { contatos: [], enderecos: [] } as IParceiro
  ): void {
    this.entity.parceiro = parceiro;
    this._fastEndereco.updateFormValue(parceiro.enderecos);
    this._fastContato.updateValues(parceiro);
  }

  get formValid(): boolean {
    return this.viewInit && this._fastEndereco.form.valid && this.form.valid;
  }

  get formAddressValid(): boolean {
    if (this.viewInit && this._fastEndereco.form.invalid)
      this._fastEndereco.form.markAllAsTouched();
    return this.viewInit && this._fastEndereco.form.invalid;
  }

  get formDadosValid() {
    if (this.viewInit && this.form.invalid) this.form.markAllAsTouched();
    return this.viewInit && this.form.invalid;
  }

  notText(event) {
    if (
      (!/^\d+$/.test(event.key) || /[`,.]/.test(event.key)) &&
      event.key !== 'Backspace' &&
      event.key !== 'Delete' &&
      event.key !== 'Tab' &&
      event.key !== 'ArrowLeft' &&
      event.key !== 'ArrowRight' &&
      !event.ctrlKey
    )
      return false;
  }

  public checkRgInscEstadual(): void {
    const rgInsc = this.form.controls.rg_insc_est;

    if (
      rgInsc.value === null ||
      rgInsc.invalid ||
      rgInsc.value === '' ||
      this.findParceiro
    )
      return;
    const rgInscValue: string = rgInsc.value.replace(/[^a-zA-Z0-9 ]/g, '');

    this.parceiroService
      .getEntitiesByParams(
        `rg_insc_est=${rgInscValue}`,
        this.tokenService.getDomain().id
      )
      .subscribe(
        (parceiro: IParceiro) => {
          if (parceiro[0] && parceiro[0].id) {
            this.form.controls.rg_insc_est.setErrors({ duplicate: true });
            this.form.updateValueAndValidity();
            return {} as IParceiro;
          }
        },
        (err: HttpErrorResponse) => this.displayError(err)
      );
  }

  /**
   * Abre um dialog que contém a consulta na predictus
   */
  openDialogConsultaPredictus() {
    this.loadingParceiro = true;
    const cpfCnpjValue: string = this.form.controls.cpf_cnpj.value.replace(
      /\D/g,
      ''
    );

    this.domainService.consultaPredictus(cpfCnpjValue).subscribe(
      (response: any) => {
        response.contatos = [];
        this.loadingParceiro = false;
        this.matDialog
          .open(DialogConsultaPredictusComponent, {
            data: { data: response, usaCnae: false },
            panelClass: ['transparent-dialog']
          })
          .afterClosed()
          .subscribe((res: IParceiro) => {
            if (res) {
              this.setInformacoesParceiro({
                ...res,
                id: this.entity?.id
              });
              this.form.patchValue({
                apelido_nome_fantasia: res.apelido_nome_fantasia || null,
                nome_razao_social: res.nome_razao_social || null,
                rg_insc_est: res.rg_insc_est || null,
                data_nascimento: res.data_nascimento || null
              });
            }
          });
      },
      (err: HttpErrorResponse) => {
        this.loadingParceiro = false;
        this.displayError(err, false);
      }
    );
  }

  public checkCpfCnpj(): void {
    const cpfCnpj = this.form.controls.cpf_cnpj;

    if (
      !cpfCnpj.value ||
      cpfCnpj.value === undefined ||
      cpfCnpj.value.length < 11 ||
      cpfCnpj.hasError('validateCPF') ||
      cpfCnpj.hasError('validateCNPJ')
    )
      return;
    const cpfCnpjValue: string = cpfCnpj.value.replace(/\D/g, '');
    this.loadingParceiro = true;
    this.parceiroService
      .getEntitiesByParams(
        `cpf_cnpj=${cpfCnpjValue}`,
        this.tokenService.getDomain().id
      )
      .pipe(
        map(parceiros => {
          if (parceiros.length) {
            this.findParceiro = true;
            return { ...parceiros[0], cpf_cnpj: parceiros[0].cpf_cnpj.trim() };
          }
          this.findParceiro = false;
          return { contatos: [], enderecos: [] } as IParceiro;
        }),
        mergeMap(parceiro => {
          if (!parceiro || !parceiro.id || parceiro.id === this.entity.id)
            return of(parceiro);
          return this.entityService.getEntity(parceiro.id).pipe(
            map(ent => {
              if (ent && ent.id) {
                this.form.controls.cpf_cnpj.setErrors({ duplicate: true });
                this.form.updateValueAndValidity();
                return { contatos: [], enderecos: [] } as IParceiro;
              }
              return parceiro;
            }),
            catchError(() => of(parceiro))
          );
        })
      )
      .subscribe(
        (parceiro: IParceiro) => {
          this.loadingParceiro = false;
          if (!parceiro || !parceiro.id) {
            this.entity.parceiro.id = null;
            return;
          } else {
            this.setInformacoesParceiro(parceiro);
            this.form.patchValue({
              apelido_nome_fantasia: parceiro.apelido_nome_fantasia || null,
              nome_razao_social: parceiro.nome_razao_social || null,
              rg_insc_est: parceiro.rg_insc_est || null,
              data_nascimento: parceiro.data_nascimento || null
            });
          }
        },
        (err: HttpErrorResponse) => {
          this.loadingParceiro = false;
          this.displayError(err);
        }
      );
  }

  checkCNH() {
    const cnhValue = this.form.controls.cnh;

    if (cnhValue.invalid) return;
    const cnh: string = cnhValue.value;

    this.entityService
      .getEntitiesByParams(`cnh=${cnh}`, this.tokenService.getDomain().id)
      .subscribe(
        (motorista: IMotorista[]) => {
          if (motorista.length !== 0) {
            cnhValue.setErrors({ duplicate: true });
          }
        },
        (err: HttpErrorResponse) => this.displayError(err)
      );
  }

  getValues() {
    let motorista: IMotorista = { ...this.form.value };
    // limpa as informações com null
    motorista = Utils.onlyAttributes(Utils.clearObject(motorista), [
      'nome_razao_social',
      'apelido_nome_fantasia',
      'data_nascimento',
      'cpf_cnpj',
      'rg_insc_est'
    ]);
    return motorista;
  }

  onSubmit(): void {
    const entity: IMotorista | any = Utils.clearObject<IMotorista>({
      ...this.entity,
      parceiro: Utils.clearObject({
        ...this.entity.parceiro,
        ...this.getValues(),
        enderecos: this._fastEndereco.getValues(),
        contatos: this._fastContato.getValues()
      }),
      cnh: Utils.trimAttributes(this.form.value.cnh),
      cnh_validade: this.form.value.cnh_validade,
      cnh_categoria: this.form.value.cnh_categoria,
      data_nascimento: this.form.value.data_nascimento,
      domain_id: this.tokenService.getDomain().id
    } as IMotorista);
    entity.parceiro = Utils.trimAttributes(entity.parceiro);
    entity.parceiro = Utils.clearEmptyString(entity.parceiro);
    if (
      this.form.value.data_nascimento === undefined ||
      this.form.value.data_nascimento === null
    ) {
      entity.parceiro.data_nascimento = null;
      entity.data_nascimento = null;
    }
    this.insert(entity);
  }

  insert(entity: IMotorista): void {
    if (entity.parceiro.id) {
      zip(
        this.parceiroService.update({
          ...entity.parceiro
        }),
        this.entityService.insert({
          ...entity,
          id: entity.parceiro.id,
          parceiro: undefined
        })
      )
        .pipe(
          mergeMap(([, motorista]) => {
            return this.entityService.getEntity(motorista.id, ['parceiro']);
          })
        )
        .subscribe(
          motorista => {
            this.matSnackBar.open('Motorista criado com sucesso.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-success']
            });
            this.dialogRef.close(motorista);
          },
          (err: HttpErrorResponse) => this.displayError(err)
        );
    } else {
      this.parceiroService
        .insert({
          ...entity.parceiro,
          domain_id: this.tokenService.getDomain().id
        })
        .pipe(
          mergeMap(parceiro => {
            return this.entityService.insert({
              ...entity,
              id: parceiro.id,
              parceiro: undefined
            });
          }),
          mergeMap(motorista => {
            return this.entityService.getEntity(motorista.id, ['parceiro']);
          })
        )
        .subscribe(
          motorista => {
            this.matSnackBar.open('Motorista criado com sucesso.', 'X', {
              duration: 2000,
              horizontalPosition: 'right',
              verticalPosition: 'top',
              panelClass: ['msg-success']
            });
            this.dialogRef.close(motorista);
          },
          (err: HttpErrorResponse) => this.displayError(err)
        );
    }
  }

  ngAfterViewInit(): void {
    this.viewInit = true;
    if (this.screenService.detectDeviceInfo().isMobile)
      this.fastMotorista.maximize();
  }

  /**
   * Valida as rotas do usuário
   * @param routes
   * @param url_name
   * @returns
   */
  verificarRotasDeAcesso(routes: IRoute[], url_name: string): IRoute[] {
    if (routes && routes.length > 0 && url_name) {
      return routes.filter(r => new RegExp(`^${url_name}`).test(r.url));
    }
  }

  /**
   * Valida se as rotas do usuário são equivalentes ao pacote de rotas do fiscal
   * @param routesAuthorization
   * @param action
   * @param params
   * @param url_name
   * @returns
   */
  validarAdicao(
    routesAuthorization: IRoute[],
    action: string,
    params = '',
    url_name: string
  ): boolean {
    if (routesAuthorization && routesAuthorization.length > 0) {
      const url_return = routesAuthorization.find(
        route => route.url === url_name && route.method === action
      );
      return !!url_return;
    }
  }

  onFocus(event, input?: boolean) {
    if (input !== undefined && input !== null)
      if (document.activeElement.id === this.ID_FIELD_DTNASC) {
        this.inputElementDtNasc =
          event?.target?.id === document.activeElement.id;
      } else if (document.activeElement.id === this.ID_FIELD_DTCNH) {
        this.inputElementDtCNH =
          event?.target?.id === document.activeElement.id;
      } else {
        this.inputElementDtCNH = false;
        this.inputElementDtNasc = false;
      }
    if (event) {
      this.focusElement = event.target?.id;
    } else {
      this.focusElement = null;
    }
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = false) {
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      dialogComponent: ConfirmDialogComponent,
      matDialog: this.matDialog,
      dialogData: {
        config: {
          data: {
            title: 'Aviso - Erro ao realizar operação',
            bodyMessage: err.error,
            icon: 'warning',
            icon_color: 'accent',
            singleBtn: true
          } as ConfirmDialogData,
          disableClose: true,
          width: '500px'
        } as MatDialogConfig<any>
      }
    } as IErroMessages);
    errorMsg.showMessageObject(err.error);
    // errorMsg.checkError();
  }
}
